import { Loader } from "@circle-react-uikit/Loader";
import { cannotPurchaseAgain } from "@circle-react/helpers/paywallCheckoutHelpers";

import { DefaultFullPreview } from "./DefaultFullPreview";
import { ModalPreview } from "./ModalPreview";
import { usePricePreviewContext } from "./PricePreviewProvider";

type VARIANT_TYPE = "classical" | "with_modals" | "mobile_fixed_on_top";

interface PricePreviewProp {
  variant?: VARIANT_TYPE;
}

export const PricePreview = ({ variant = "classical" }: PricePreviewProp) => {
  const { previewMutation, hasAlreadyPurchased, paywall } =
    usePricePreviewContext();
  const { data: preview } = previewMutation;

  if (variant === "with_modals") {
    return <ModalPreview />;
  }

  if (variant === "mobile_fixed_on_top") {
    return <ModalPreview.MobileFixedOnTopPreview />;
  }

  if (previewMutation.isPending) {
    return <Loader variant="default" />;
  }

  if (
    cannotPurchaseAgain(hasAlreadyPurchased, paywall) ||
    previewMutation.isIdle ||
    previewMutation.isError ||
    !preview
  ) {
    return null;
  }

  return <DefaultFullPreview preview={preview} />;
};
